<template>
  <!-- 角色管理 -->
  <div class="page">
    <!-- 搜索区域 -->
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="auto" class="from">
        <el-form-item :label="$t('pages.system.text91')">
          <el-input
            v-model="searchParams.roleName"
            :placeholder="$t('public.text1')"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="searchSubmit">
        <DiluButton
          type="search"
          @click="search"
          v-permission="['roleManagement:query']"
        ></DiluButton>
        <DiluButton
          type="reset"
          @click="reset"
          v-permission="['roleManagement:reset']"
        ></DiluButton>
      </div>
    </div>

    <!-- 按钮区域 -->
    <div class="operation">
      <DiluButton
        type="add"
        @click="add"
        v-permission="['roleManagement:add']"
      ></DiluButton>
    </div>

    <!-- 表格 -->
    <DiluTable
      :list="tableData"
      :tableConfig="tableConfig"
      :total="total"
      :pageSize="searchParams.pageSize"
      @currentChange="currentChange"
    >
      <el-table-column prop="date" label="#" width="80" align="center">
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="roleName"
        :label="$t('pages.system.text91')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="createdAt"
        :label="$t('pages.system.text71')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="accountNum"
        :label="$t('pages.system.text92')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="address"
        :label="$t('public.text4')"
        align="center"
        fixed="right"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button
              @click="see(scope.row)"
              type="text"
              v-permission="['roleManagement:see']"
              >{{ $t("button.look") }}</el-button
            >
            <el-button
              @click="edit(scope.row)"
              type="text"
              v-permission="['roleManagement:edit']"
              >{{ $t("button.edit") }}</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.accountNum != 0"
              v-permission="['roleManagement:remove']"
              disabled
              >{{ $t("button.delete") }}</el-button
            >
            <el-button
              @click="remove(scope.row)"
              type="text"
              v-permission="['roleManagement:remove']"
              v-else
              >{{ $t("button.delete") }}</el-button
            >
          </div>
        </template>
      </el-table-column>
    </DiluTable>

    <!-- 新增弹窗 -->
    <RoleManageMentAdd
      @dialogClose="dialogClose"
      @roleManagementList="roleManagementList"
      :dialogVisible="dialogVisible"
      :isAdd="isAdd"
      :currentRole="currentRole"
    />
  </div>
</template>


<script>
import DiluButton from "../../../components/pubilc/dilu-button.vue";
import DiluTable from "../../../components/pubilc/dilu-table.vue";
import RoleManageMentAdd from "./module/roleManageMentAdd.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      currentRole: {},
      isAdd: 0, //新增1，编辑2，查看3
      searchParams: {
        belongCustomerId: "", //平台方id
        pageNum: 1, //页码
        pageSize: 10, //每页条数
        roleName: "", //角色名称
      }, // 搜索条件
      dialogVisible: false, //新增编辑弹窗
      tableConfig: {
        isTree: false,
        isPage: true,
      },
      tableData: [],
      total: 0,
      isSerch: false, //是否在查询
    };
  },
  computed: {
    ...mapState(["platformData"]),
  },
  components: {
    DiluTable,
    DiluButton,
    RoleManageMentAdd,
  },
  mounted() {
    this.roleManagementList();
  },
  methods: {
    //搜索
    search() {
      this.isSerch = true; //是否在查询
      this.searchParams.pageNum = 1;
      this.total = 0;
      this.roleManagementList();
    },
    //关闭新增编辑弹窗
    dialogClose() {
      this.dialogVisible = false;
    },
    //重置
    reset() {
      this.isSerch = false; //是否在查询
      this.searchParams.pageNum = 1;
      this.searchParams.pageSize = 10;
      this.searchParams.roleName = "";
      this.total = 0;
      this.roleManagementList();
    },
    //新增
    add() {
      this.isAdd = 1;
      this.dialogVisible = true;
    },
    //查看
    see(e) {
      this.currentRole = e;
      this.roleManagementInfo(e.id, 3, 0);
    },
    //编辑
    edit(e) {
      this.currentRole = e;
      this.roleManagementInfo(e.id, 2, 1);
    },
    //角色管理-根据id查询菜单按钮权限
    roleManagementInfo(id, i, j) {
      let str = "?id=" + id + "&flag=" + j;
      this.request.roleManagementInfo(str).then((res) => {
        let arr = [];
        let arr1 = [];
        for (let i in res.data.buttons) {
          arr.push(-res.data.buttons[i].id);
        }
        for (let i in res.data.menus) {
          arr1.push(res.data.menus[i].id);
        }
        this.currentRole.menuIds = arr1;
        this.currentRole.buttonIds = arr;
        this.currentRole.treeList = res.data.treeList;
        this.isAdd = i;
        this.dialogVisible = true;
      });
    },
    //翻页
    currentChange(e) {
      if (!this.isSerch) {
        this.searchParams.pageNum = 1;
        this.searchParams.pageSize = 10;
        this.searchParams.roleName = "";
      }
      this.searchParams.pageNum = e;
      this.roleManagementList();
    },
    //删除
    remove(e) {
      this.$confirm(this.$t("pages.system.text93"), this.$t("public.text6"), {
        confirmButtonText: this.$t("button.determine"),
        cancelButtonText: this.$t("button.cancel"),
        type: "warning",
      })
        .then(() => {
          let str = "?id=" + e.id;
          this.request.roleManagementDelete(str).then(() => {
            this.$message.success(this.$t("public.text7"));
            this.roleManagementList();
          });
        })
        .catch(() => {});
    },
    //查询列表
    roleManagementList() {
      setTimeout(() => {
        this.searchParams.belongCustomerId = this.platformData.id;
        this.request.roleManagementList(this.searchParams).then((res) => {
          this.tableData = res.data;
          this.total = res.dataMaxCount;
        }, 200);
      });
    },
  },
};
</script>

<style scoped>
.page {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.from {
  float: left;
  display: flex;
}
.searchSubmit {
  float: right;
  display: flex;
}
.operation {
  margin-bottom: 20px;
  display: flex;
}
</style>